[
  {
    "slug": "PIA_LGL_FOND",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_FOND.name",
    "description": "knowledge_base.slugs.PIA_LGL_FOND.description"
  },
  {
    "slug": "PIA_LGL_ST",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_ST.name",
    "description": "knowledge_base.slugs.PIA_LGL_ST.description"
  },
  {
    "slug": "PIA_LGL_TRAN",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_TRAN.name",
    "description": "knowledge_base.slugs.PIA_LGL_TRAN.description"
  },
  {
    "slug": "PIA_LGL_DESC",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_DESC.name",
    "description": "knowledge_base.slugs.PIA_LGL_DESC.description"
  },
  {
    "slug": "PIA_LGL_DATA",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_DATA.name",
    "description": "knowledge_base.slugs.PIA_LGL_DATA.description"
  },
  {
    "slug": "PIA_LGL_SUPT",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_SUPT.name",
    "description": "knowledge_base.slugs.PIA_LGL_SUPT.description"
  },
  {
    "slug": "PIA_LGL_FIN",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_FIN.name",
    "description": "knowledge_base.slugs.PIA_LGL_FIN.description"
  },
  {
    "slug": "PIA_LGL_MINI",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_MINI.name",
    "description": "knowledge_base.slugs.PIA_LGL_MINI.description"
  },
  {
    "slug": "PIA_LGL_DEST",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_DEST.name",
    "description": "knowledge_base.slugs.PIA_LGL_DEST.description"
  },
  {
    "slug": "PIA_LGL_DUR",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_DUR.name",
    "description": "knowledge_base.slugs.PIA_LGL_DUR.description"
  },
  {
    "slug": "PIA_LGL_INFO",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_INFO.name",
    "description": "knowledge_base.slugs.PIA_LGL_INFO.description"
  },
  {
    "slug": "PIA_LGL_CONS",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_LGL_CONS.name",
    "description": "knowledge_base.slugs.PIA_LGL_CONS.description"
  },
  {
    "slug": "PIA_VAL_DPO",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_VAL_DPO.name",
    "description": "knowledge_base.slugs.PIA_VAL_DPO.description"
  },
  {
    "slug": "PIA_VAL_CONC",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_VAL_CONC.name",
    "description": "knowledge_base.slugs.PIA_VAL_CONC.description"
  },
  {
    "slug": "PIA_VAL_RT",
    "filters": "",
    "category": "knowledge_base.category.principle",
    "name": "knowledge_base.slugs.PIA_VAL_RT.name",
    "description": "knowledge_base.slugs.PIA_VAL_RT.description"
  },
  {
    "slug": "PIA_TEC_CHIF",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_CHIF.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_CHIF.name",
    "description": "knowledge_base.slugs.PIA_TEC_CHIF.description"
  },
  {
    "slug": "PIA_TEC_ANO",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_ANO.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_ANO.name",
    "description": "knowledge_base.slugs.PIA_TEC_ANO.description"
  },
  {
    "slug": "PIA_TEC_CLO",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_CLO.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_CLO.name",
    "description": "knowledge_base.slugs.PIA_TEC_CLO.description"
  },
  {
    "slug": "PIA_TEC_CTLA",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_CTLA.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_CTLA.name",
    "description": "knowledge_base.slugs.PIA_TEC_CTLA.description"
  },
  {
    "slug": "PIA_TEC_LOG",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_LOG.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_LOG.name",
    "description": "knowledge_base.slugs.PIA_TEC_LOG.description"
  },
  {
    "slug": "PIA_TEC_ARCH",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_ARCH.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_ARCH.name",
    "description": "knowledge_base.slugs.PIA_TEC_ARCH.description"
  },
  {
    "slug": "PIA_TEC_PAP",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_PAP.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_PAP.name",
    "description": "knowledge_base.slugs.PIA_TEC_PAP.description"
  },
  {
    "slug": "PIA_TEC_MINI",
    "filters": "measure.data_processing",
    "category": "knowledge_base.category.measure_on_data",
    "placeholder": "knowledge_base.slugs.PIA_TEC_MINI.placeholder",
    "name": "knowledge_base.slugs.PIA_TEC_MINI.name",
    "description": "knowledge_base.slugs.PIA_TEC_MINI.description"
  },
  {
    "slug": "PIA_SEC_EXP",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_EXP.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_EXP.name",
    "description": "knowledge_base.slugs.PIA_SEC_EXP.description"
  },
  {
    "slug": "PIA_SEC_MAL",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_MAL.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_MAL.name",
    "description": "knowledge_base.slugs.PIA_SEC_MAL.description"
  },
  {
    "slug": "PIA_SEC_COMP",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_COMP.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_COMP.name",
    "description": "knowledge_base.slugs.PIA_SEC_COMP.description"
  },
  {
    "slug": "PIA_SEC_WEB",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_WEB.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_WEB.name",
    "description": "knowledge_base.slugs.PIA_SEC_WEB.description"
  },
  {
    "slug": "PIA_SEC_BKP",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_BKP.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_BKP.name",
    "description": "knowledge_base.slugs.PIA_SEC_BKP.description"
  },
  {
    "slug": "PIA_SEC_MAIN",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_MAIN.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_MAIN.name",
    "description": "knowledge_base.slugs.PIA_SEC_MAIN.description"
  },
  {
    "slug": "PIA_SEC_CTR",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_CTR.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_CTR.name",
    "description": "knowledge_base.slugs.PIA_SEC_CTR.description"
  },
  {
    "slug": "PIA_SEC_NET",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_NET.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_NET.name",
    "description": "knowledge_base.slugs.PIA_SEC_NET.description"
  },
  {
    "slug": "PIA_SEC_PHY",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_PHY.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_PHY.name",
    "description": "knowledge_base.slugs.PIA_SEC_PHY.description"
  },
  {
    "slug": "PIA_SEC_LOG",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_LOG.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_LOG.name",
    "description": "knowledge_base.slugs.PIA_SEC_LOG.description"
  },
  {
    "slug": "PIA_SEC_MAT",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_MAT.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_MAT.name",
    "description": "knowledge_base.slugs.PIA_SEC_MAT.description"
  },
  {
    "slug": "PIA_SEC_SRC",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_SRC.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_SRC.name",
    "description": "knowledge_base.slugs.PIA_SEC_SRC.description"
  },
  {
    "slug": "PIA_SEC_PROT",
    "filters": "measure.security",
    "category": "knowledge_base.category.general_measure",
    "placeholder": "knowledge_base.slugs.PIA_SEC_PROT.placeholder",
    "name": "knowledge_base.slugs.PIA_SEC_PROT.name",
    "description": "knowledge_base.slugs.PIA_SEC_PROT.description"
  },
  {
    "slug": "PIA_ORG_ORG",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_ORG.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_ORG.name",
    "description": "knowledge_base.slugs.PIA_ORG_ORG.description"
  },
  {
    "slug": "PIA_ORG_POL",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_POL.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_POL.name",
    "description": "knowledge_base.slugs.PIA_ORG_POL.description"
  },
  {
    "slug": "PIA_ORG_RMGT",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_RMGT.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_RMGT.name",
    "description": "knowledge_base.slugs.PIA_ORG_RMGT.description"
  },
  {
    "slug": "PIA_ORG_PBD",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_PBD.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_PBD.name",
    "description": "knowledge_base.slugs.PIA_ORG_PBD.description"
  },
  {
    "slug": "PIA_ORG_VIOL",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_VIOL.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_VIOL.name",
    "description": "knowledge_base.slugs.PIA_ORG_VIOL.description"
  },
  {
    "slug": "PIA_ORG_PERS",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_PERS.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_PERS.name",
    "description": "knowledge_base.slugs.PIA_ORG_PERS.description"
  },
  {
    "slug": "PIA_ORG_EXT",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_EXT.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_EXT.name",
    "description": "knowledge_base.slugs.PIA_ORG_EXT.description"
  },
  {
    "slug": "PIA_ORG_AUD",
    "filters": "measure.governance",
    "category": "knowledge_base.category.organizational_measure",
    "placeholder": "knowledge_base.slugs.PIA_ORG_AUD.placeholder",
    "name": "knowledge_base.slugs.PIA_ORG_AUD.name",
    "description": "knowledge_base.slugs.PIA_ORG_AUD.description"
  },
  {
    "slug": "PIA_DEF_EXA",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_EXA.name",
    "description": "knowledge_base.slugs.PIA_DEF_EXA.description"
  },
  {
    "slug": "PIA_DEF_MES",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MES.name",
    "description": "knowledge_base.slugs.PIA_DEF_MES.description"
  },
  {
    "slug": "PIA_DEF_RT",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_RT.name",
    "description": "knowledge_base.slugs.PIA_DEF_RT.description"
  },
  {
    "slug": "PIA_DEF_DCP",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_DCP.name",
    "description": "knowledge_base.slugs.PIA_DEF_DCP.description"
  },
  {
    "slug": "PIA_DEF_DEST",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_DEST.name",
    "description": "knowledge_base.slugs.PIA_DEF_DEST.description"
  },
  {
    "slug": "PIA_DEF_SUPT",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_SUPT.name",
    "description": "knowledge_base.slugs.PIA_DEF_SUPT.description"
  },
  {
    "slug": "PIA_DEF_MINC",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MINC.name",
    "description": "knowledge_base.slugs.PIA_DEF_MINC.description"
  },
  {
    "slug": "PIA_DEF_MIND",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MIND.name",
    "description": "knowledge_base.slugs.PIA_DEF_MIND.description"
  },
  {
    "slug": "PIA_DEF_CONS",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_CONS.name",
    "description": "knowledge_base.slugs.PIA_DEF_CONS.description"
  },
  {
    "slug": "PIA_DEF_ACC",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_ACC.name",
    "description": "knowledge_base.slugs.PIA_DEF_ACC.description"
  },
  {
    "slug": "PIA_DEF_PORT",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_PORT.name",
    "description": "knowledge_base.slugs.PIA_DEF_PORT.description"
  },
  {
    "slug": "PIA_DEF_RECT",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_RECT.name",
    "description": "knowledge_base.slugs.PIA_DEF_RECT.description"
  },
  {
    "slug": "PIA_DEF_EFF",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_EFF.name",
    "description": "knowledge_base.slugs.PIA_DEF_EFF.description"
  },
  {
    "slug": "PIA_DEF_LIM",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_LIM.name",
    "description": "knowledge_base.slugs.PIA_DEF_LIM.description"
  },
  {
    "slug": "PIA_DEF_OPP",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_OPP.name",
    "description": "knowledge_base.slugs.PIA_DEF_OPP.description"
  },
  {
    "slug": "PIA_DEF_CHIF",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_CHIF.name",
    "description": "knowledge_base.slugs.PIA_DEF_CHIF.description"
  },
  {
    "slug": "PIA_DEF_ANO",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_ANO.name",
    "description": "knowledge_base.slugs.PIA_DEF_ANO.description"
  },
  {
    "slug": "PIA_DEF_PSEU",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_PSEU.name",
    "description": "knowledge_base.slugs.PIA_DEF_PSEU.description"
  },
  {
    "slug": "PIA_DEF_CLO",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_CLO.name",
    "description": "knowledge_base.slugs.PIA_DEF_CLO.description"
  },
  {
    "slug": "PIA_DEF_CTLA",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_CTLA.name",
    "description": "knowledge_base.slugs.PIA_DEF_CTLA.description"
  },
  {
    "slug": "PIA_DEF_PWD",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_PWD.name",
    "description": "knowledge_base.slugs.PIA_DEF_PWD.description"
  },
  {
    "slug": "PIA_DEF_AUTH",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_AUTH.name",
    "description": "knowledge_base.slugs.PIA_DEF_AUTH.description"
  },
  {
    "slug": "PIA_DEF_LOG",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_LOG.name",
    "description": "knowledge_base.slugs.PIA_DEF_LOG.description"
  },
  {
    "slug": "PIA_DEF_ARCH",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_ARCH.name",
    "description": "knowledge_base.slugs.PIA_DEF_ARCH.description"
  },
  {
    "slug": "PIA_DEF_MIN1",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MIN1.name",
    "description": "knowledge_base.slugs.PIA_DEF_MIN1.description"
  },
  {
    "slug": "PIA_DEF_MIN2",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MIN2.name",
    "description": "knowledge_base.slugs.PIA_DEF_MIN2.description"
  },
  {
    "slug": "PIA_DEF_SRC",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_SRC.name",
    "description": "knowledge_base.slugs.PIA_DEF_SRC.description"
  },
  {
    "slug": "PIA_DEF_MEN",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MEN.name",
    "description": "knowledge_base.slugs.PIA_DEF_MEN.description"
  },
  {
    "slug": "PIA_DEF_MENA",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MENA.name",
    "description": "knowledge_base.slugs.PIA_DEF_MENA.description"
  },
  {
    "slug": "PIA_DEF_MENM",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MENM.name",
    "description": "knowledge_base.slugs.PIA_DEF_MENM.description"
  },
  {
    "slug": "PIA_METHOD_MES",
    "filters": "",
    "category": "knowledge_base.category.method",
    "name": "knowledge_base.slugs.PIA_METHOD_MES.name",
    "description": "knowledge_base.slugs.PIA_METHOD_MES.description"
  },
  {
    "slug": "PIA_DEF_MENI",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MENI.name",
    "description": "knowledge_base.slugs.PIA_DEF_MENI.description"
  },
  {
    "slug": "PIA_DEF_GRV",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_GRV.name",
    "description": "knowledge_base.slugs.PIA_DEF_GRV.description"
  },
  {
    "slug": "PIA_DEF_VRA",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_VRA.name",
    "description": "knowledge_base.slugs.PIA_DEF_VRA.description"
  },
  {
    "slug": "PIA_DEF_PBDS",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_PBDS.name",
    "description": "knowledge_base.slugs.PIA_DEF_PBDS.description"
  },
  {
    "slug": "PIA_DEF_VIOL",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_VIOL.name",
    "description": "knowledge_base.slugs.PIA_DEF_VIOL.description"
  },
  {
    "slug": "PIA_VAL_CART",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_VAL_CART.name",
    "description": "knowledge_base.slugs.PIA_VAL_CART.description"
  },
  {
    "slug": "PIA_VAL_ACT",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_VAL_ACT.name",
    "description": "knowledge_base.slugs.PIA_VAL_ACT.description"
  },
  {
    "slug": "PIA_DEF_ENJ",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_ENJ.name",
    "description": "knowledge_base.slugs.PIA_DEF_ENJ.description"
  },
  {
    "slug": "PIA_DEF_ST",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_ST.name",
    "description": "knowledge_base.slugs.PIA_DEF_ST.description"
  },
  {
    "slug": "PIA_DEF_RGPD",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_RGPD.name",
    "description": "knowledge_base.slugs.PIA_DEF_RGPD.description"
  },
  {
    "slug": "PIA_DEF_PC",
    "filters": "",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_PC.name",
    "description": "knowledge_base.slugs.PIA_DEF_PC.description"
  },
  {
    "slug": "PIA_DEF_MIN3",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MIN3.name",
    "description": "knowledge_base.slugs.PIA_DEF_MIN3.description"
  },
  {
    "slug": "PIA_DEF_MIN4",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MIN4.name",
    "description": "knowledge_base.slugs.PIA_DEF_MIN4.description"
  },
  {
    "slug": "PIA_DEF_MIN5",
    "filters": "measure.definition",
    "category": "knowledge_base.category.definition",
    "name": "knowledge_base.slugs.PIA_DEF_MIN5.name",
    "description": "knowledge_base.slugs.PIA_DEF_MIN5.description"
  },
  {
    "slug": "PIA_EX_DCPC",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_DCPC.name",
    "description": "knowledge_base.slugs.PIA_EX_DCPC.description"
  },
  {
    "slug": "PIA_EX_DCPS",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_DCPS.name",
    "description": "knowledge_base.slugs.PIA_EX_DCPS.description"
  },
  {
    "slug": "PIA_EX_DCPR",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_DCPR.name",
    "description": "knowledge_base.slugs.PIA_EX_DCPR.description"
  },
  {
    "slug": "PIA_EX_HUMI",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_HUMI.name",
    "description": "knowledge_base.slugs.PIA_EX_HUMI.description"
  },
  {
    "slug": "PIA_EX_HUME",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_HUME.name",
    "description": "knowledge_base.slugs.PIA_EX_HUME.description"
  },
  {
    "slug": "PIA_EX_NHUM",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_NHUM.name",
    "description": "knowledge_base.slugs.PIA_EX_NHUM.description"
  },
  {
    "slug": "PIA_EX_IMPN",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_IMPN.name",
    "description": "knowledge_base.slugs.PIA_EX_IMPN.description"
  },
  {
    "slug": "PIA_EX_IMPL",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_IMPL.name",
    "description": "knowledge_base.slugs.PIA_EX_IMPL.description"
  },
  {
    "slug": "PIA_EX_IMPI",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_IMPI.name",
    "description": "knowledge_base.slugs.PIA_EX_IMPI.description"
  },
  {
    "slug": "PIA_EX_IMPM",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_IMPM.name",
    "description": "knowledge_base.slugs.PIA_EX_IMPM.description"
  },
  {
    "slug": "PIA_EX_VRAN",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_VRAN.name",
    "description": "knowledge_base.slugs.PIA_EX_VRAN.description"
  },
  {
    "slug": "PIA_EX_VRAL",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_VRAL.name",
    "description": "knowledge_base.slugs.PIA_EX_VRAL.description"
  },
  {
    "slug": "PIA_EX_VRAI",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_VRAI.name",
    "description": "knowledge_base.slugs.PIA_EX_VRAI.description"
  },
  {
    "slug": "PIA_EX_VRAM",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_VRAM.name",
    "description": "knowledge_base.slugs.PIA_EX_VRAM.description"
  },
  {
    "slug": "PIA_EX_DC",
    "filters": "",
    "category": "knowledge_base.category.example",
    "name": "knowledge_base.slugs.PIA_EX_DC.name",
    "description": "knowledge_base.slugs.PIA_EX_DC.description"
  }
]
